module.exports = __webpack_public_path__ + "img/joki_ja_vene.0ee945b4.jpeg";